import {
  LIST_SEGMENT_REQUEST,
  LIST_SEGMENT_SUCCESS,
  LIST_SEGMENT_ERROR,
  RESET_STATE_ALL_APPLICATION,
  RESET_STATE_REDUX,
} from '../../actions';

const INIT_STATE = {
  currentSegmentList: null,
  loading: false,
  success: '',
  error: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_STATE_ALL_APPLICATION:
      return INIT_STATE;
    case RESET_STATE_REDUX:
      return {
        ...state,
        error: '',
        success: '',
      };
    case LIST_SEGMENT_REQUEST:
      return { ...state, loading: true, error: '' };
    case LIST_SEGMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        currentSegmentList: action.payload,
        error: '',
      };
    case LIST_SEGMENT_ERROR:
      return {
        ...state,
        loading: false,
        currentSegmentList: null,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};
